import { useState } from 'react';
import { MultiPanelTile, Panel, PanelAction, Tooltip } from '@dsi/react-eds';

import ReactEDSWrapper from '../../utils/react-eds-wrapper';
import PipelineSummary from './Summary';
import PipelineTable from './PipelineTable';
import { usePipelineData } from '../../hooks/usePipelineData';
import { usePipelineSummary } from '../../hooks/usePipelineSummary';
import { useSearchParams } from 'react-router-dom';

export default function Pipeline() {
  const [leftPanelOpen, setLeftPanelOpen] = useState(true);
  const [searchParams] = useSearchParams();
  const pipelineData = usePipelineData(searchParams.get('status') || undefined);
  const statsData = usePipelineSummary();

  return (
    <ReactEDSWrapper
      component={MultiPanelTile}
      title="Automation Workflow Runs"
      style={{ overflowX: 'auto', overflowY: 'auto', height: 'calc(100vh - 100px)' }}
      leftPanelAction={
        <ReactEDSWrapper component={Tooltip} message="Toggle filters" pointer>
          <ReactEDSWrapper
            component={PanelAction}
            icon={leftPanelOpen ? 'sidemenu-left-close' : 'sidemenu-left-open'}
            onClick={() => setLeftPanelOpen(!leftPanelOpen)}
          />
        </ReactEDSWrapper>
      }
      leftPanel={
        <ReactEDSWrapper component={Panel} title="Automation Workflow Summary" onClose={() => setLeftPanelOpen(false)}>
          <PipelineSummary pipelineData={statsData} />
        </ReactEDSWrapper>
      }
      leftPanelOpen={leftPanelOpen}
    >
      {pipelineData.paginatedData.limit !== 0 && <PipelineTable pipelineData={pipelineData.paginatedData} />}
    </ReactEDSWrapper>
  );
}
